function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-Assets_Icon"
}, React.createElement("rect", {
  width: 26,
  height: 15
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Assets_Icon",
  "data-name": "Assets Icon",
  clipPath: "url(#clip-Assets_Icon)"
}, React.createElement("rect", {
  width: 26,
  height: 15,
  fill: "rgba(255,255,255,0)"
}), React.createElement("path", {
  id: "Path_157",
  "data-name": "Path 157",
  d: "M3,15.85H5.95V12.9H3Zm0,5.9H5.95V18.8H3ZM3,9.95H5.95V7H3Zm5.9,5.9H29.55V12.9H8.9Zm0,5.9H29.55V18.8H8.9ZM8.9,7V9.95H29.55V7Z",
  transform: "translate(-2.975 -7.075)",
  fill: "#38b1df"
}));

var SvgAssetsIcon = function SvgAssetsIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 26,
    height: 15,
    viewBox: "0 0 26 15",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAssetsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/assets-icon.63678d3e.svg";
export { ForwardRef as ReactComponent };